/* tslint:disable:indent */
import {ADAPTE} from '../../adapte/models/adapte';
import {DIVERS} from '../../divers/common/models/Typedivers';
import {FNSimple} from '../../fnsimple/common/models/FNSimple';
import {MAPA} from '../../mapa/common/models/MAPA';
import {TypeIndexation} from './type.indexation';
import {ContractAwardNotice} from '../../eforms/model/forms/contractawardnotice/ContractAwardNotice';
import {ContractNotice} from '../../eforms/model/forms/contractnotice/ContractNotice';
import {
  BusinessRegistrationInformationNotice
} from '../../eforms/model/forms/eforms_business_registration_information_notice/BusinessRegistrationInformationNotice';
import {PriorInformationNotice} from '../../eforms/model/forms/priorinformationnotice/PriorInformationNotice';
import { TypeFacturation } from '../../../../models/eforms/dila/TypeFacturation';
import {v4 as uuidv4} from 'uuid';

export class TypeAnn {
  public idAnnEmetteur: string;
  public mapa: MAPA;
  public indexation: TypeIndexation;
  public fnSimple: FNSimple;
  public divers: DIVERS;
  public formAD: ADAPTE;
  public eforms: any;
  public contractAwardNotice: ContractAwardNotice;
  public contractNotice: ContractNotice;
  public businessRegistrationInformationNotice: BusinessRegistrationInformationNotice;
  public priorInformationNotice: PriorInformationNotice;
  public facturation: TypeFacturation;
  public dateEnvoi: Date;


  constructor() {
    this.idAnnEmetteur = '';
    this.fnSimple = new FNSimple();
    this.indexation = new TypeIndexation();
    this.divers = new DIVERS();
    this.mapa = new MAPA();
    this.formAD = new ADAPTE();
    this.eforms = {};
    this.contractAwardNotice = null;
    this.contractNotice = null;
    this.businessRegistrationInformationNotice = null;
    this.priorInformationNotice = null;
    this.facturation = new TypeFacturation();
  }
}
